import React from "react";
import "./LetStart.css";
import Logo from "../../assets/logo.png";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const LetStart = () => {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <div className="container">
        <img src={Logo} alt="logo" width="30%" />
        <div style={{ fontSize: "1.5rem", fontWeight: 700 }}>
          {/* <span>Welcome To-</span> */}
          <span style={{ color: "#4A3AFF" }}>Welcome To PROPLE</span>
        </div>
        <Button
          type="primary"
          shape="round"
          size="large"
          onClick={() => navigate("/login")}
        >
          Lets Get Started
          <ArrowRightOutlined />
        </Button>
      </div>
      <div className="copyright">
        Copyright © 2026 Procloz Services Pvt Ltd | All Rights Reserved
      </div>
    </div>
  );
};

export default LetStart;
